// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3ZXyD","colCheckbox":"styles_colCheckbox__1XAnD"};